import axios from "axios";
import { IRecordCreate } from "../interfaces/interfaces";
import { adapterItemResponse } from "./adapters/adapterItem";

export const createRecordInDb = async (dataRecord: IRecordCreate) => {
  try {
    let newRecord: any = await axios({
      method: "post",
      url: "/api/create-record",
      data: dataRecord,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.data;
      });

    if (newRecord.create === true) {
      let adaptedResponse = adapterItemResponse(newRecord);
      return adaptedResponse;
    }
    if (newRecord.create === false) {
      return false;
    }
    return false;
  } catch (error) {
    return false;
  }
};
